export enum connectionTypes {
  linkedin = 'linkedin',
  facebook = 'facebook',
  google = 'google-oauth2'
}
